/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState} from "react";
import { Link} from "react-router-dom";
import "jspdf-autotable";
import ajaxAdmin from "../../util/remote/ajaxAdmin";
import AppContainer from "../../Components/Structure/AppContainer";
import TableHeader from "../../Components/Common/TableHeader";
import SearchForm from "../../Components/Common/SearchForm";
import Loader from "../../Components/Common/Loader";
import Pagination from "../../Components/Common/Pagination";

function FingerprintNotificationPage() {

    const [printNotifications, setPrintNotifications] = useState([]);
    const [page,setPage] = useState(1)
    const [meta,setMeta] = useState([])
    const [loading,setLoading] = useState(false)
    const [loading2, setLoading2] = useState(false);
    const [query, setQuery] = useState("");

    useEffect(() => {
        if (query) {
        searchNotifs();
        } else {
        getNotifList(page);
        }
    }, [page]);

    const refreshData = () =>{
        getNotifList(1)
    }

    const getNotifList = async (currentPage) => {
        setLoading(true);
        const response = await ajaxAdmin.fetchPrintNotifList(currentPage);
        setLoading(false);
        if (response.status === "OK") {
        setMeta(response.details.meta.totalPages);
        setPrintNotifications(response.details.data || []);
        } else {
        setPrintNotifications([]);
        }
    };
  
    const searchNotifs = async (e) => {
          if (e) {
            e.preventDefault();
          }
          setLoading2(true);
          const server_response = await ajaxAdmin.searchPrintNotifList(page,query);
          setLoading2(false);
          if (server_response.status === "OK") {
            setMeta(server_response.details.meta.totalPages);
            setPrintNotifications(server_response.details.data || []);
          } else {
            setPrintNotifications([]);
          } 
    };

    const setNotifs = (e) => {
        e.preventDefault();
        setQuery("");
        setPage(1);
        getNotifList(1);
    };

    const handlePagination = (newPage) => {
        if (newPage > 0 && newPage <= meta) {
        setPage(newPage);
        }
    };

  

  return(
    <AppContainer title="Fingerprint Logs">
      <div className="row"> 
        <div className="col-lg-12">
          <div className="card custom-card">
            <div className="card-body map-card">
              <div class="heading-layout1 mg-b-25">
                <TableHeader
                  title="Fingerprint Logs"
                  subtitle="List of all the logs related to fingerprints sorted with the most recent"
                />
                <div class="dropdown">
                  <Link class="dropdown-toggle" role="button" data-toggle="dropdown" aria-expanded="false">...</Link>
                  <div class="dropdown-menu dropdown-menu-right">
                    <Link class="dropdown-item" onClick={refreshData} ><i class="fas fa-redo-alt text-orange-peel"></i>Refresh</Link>
                    <Link class="dropdown-item" to={"/students/import/face"} ><i class="fas fa-edit text-orange-peel"></i>Update Face Status</Link>

                  </div>
                </div>
              </div>

              <SearchForm searchTerm={query} setSearchTerm={setQuery} searchItems={searchNotifs} setItems={setNotifs} setPage={setPage} placeholder="Enter name of student..."/>

              <div className="border-top mt-3"></div>
              <div className="table-responsive">
                {loading || loading2? (
                  <Loader />
                ) : (
                  <table className="table display data-table text-nowrap">
                    <thead>
                      <tr>
                        <th scope="col">Date.</th>
                        <th scope="col">Log Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {printNotifications.length > 0 ? (
                        printNotifications.map((item, index) => (
                          <tr key={index}>
                            <td>{item.date?.long_date}</td>
                            <td>{item.message}</td>
                                
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="2" style={{ textAlign: "center" }}>
                            No fingerprint logs yet.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div>

              <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
            </div>
          </div>
        </div>
      </div> 
      
    </AppContainer>
  )
}

export default FingerprintNotificationPage;